/**
 * Returns Ant Design `<Tag color={…}>` value for a finishing place.
 * Uses the same darker bronze hex everywhere for 3rd so preset `bronze` /
 * hashed theme classes do not diverge across pages (see Results vs AthleteResults).
 */
export function podiumPlaceTagColor(place: number | null | undefined): string {
  if (place == null || Number.isNaN(place)) return 'default';
  if (place === 1) return 'gold';
  if (place === 2) return 'silver';
  if (place === 3) return '#8c5a0a';
  return 'default';
}
